/*
  This is only used by fdt (v1) and should be removed when fdt (v2) becomes
  the default.
*/

intra_module.factory('FormElementService', function() {
    let FormElement;
    return new (FormElement = class FormElement {
        constructor() {
            this.warnings = { };
            this.errors   = { };
        }

        getWarnings(reset) {
            if (reset) { return this.warnings = { }; }
            return this.warnings;
        }

        getErrors(reset) {
            if (reset) { return this.errors = { }; }
            return this.errors;
        }

        addError(field, error) {
            return this.errors[field] = error;
        }
    });
});
